<span fxLayout="column">{{'Version' | translate}} {{ version }}</span>
